// Helpers used only by the HIRE feature.
import LogManager from "../../utils/logManager";
import { fetchRtmsStatusUpdate } from "../../utils/rtmsStatusUpdateUtils";

// /rtms-status-update start|stop; a failed call resolves to {} (no `result`), which callers treat as an error.
export const updateRtms = async (action, ...args) => {
  try {
    return await fetchRtmsStatusUpdate(action, ...args);
  } catch (error) {
    LogManager.error(`[Hire] Error calling /rtms-status-update ${action}:`, error);
    return {};
  }
};
